import { Fragment } from "react";

import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import { useFetchData } from "@dzambalaorg/react-hooks";
import type { ITemplate } from "@framework/types";

import { TemplateContent } from "../../../../components";

export const Erc1155Template = () => {
  const { data: template, isLoading, isError } = useFetchData<ITemplate>("/erc1155/templates");

  if (isLoading) {
    return <Spinner />;
  }

  if (isError || !template) {
    // TODO - [AFTER ALL REFACTORING] - add universal no data component
    return <div>No data</div>;
  }

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "erc1155", "erc1155.template"]} data={[{}, {}, template]} />

      <PageHeader message="pages.erc1155.template.title" data={template} />

      <TemplateContent template={template} />
    </Fragment>
  );
};
